import React, { useContext } from "react";
import ScaleWrapper from "../components/wrappers/ScaleWrapper";
import { Navigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { AuthContext } from "../contexts/AuthContext";

export default function PublicRoutes({
  element: Component,
  restricted,
  ...rest
}) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const { loading, loggedIn } = useContext(AuthContext);

  if (loading) {
    return <div>Loading...</div>; // Display a loading indicator while checking authentication
  }

  return (
    <ScaleWrapper scale={isMobile ? 0.8 : 0.9}>
      {loggedIn ? <Navigate to="/" /> : <Component {...rest} />}
    </ScaleWrapper>
  );
}
